export const Starwars9LAscensionDeSkywalker = () => {
    let datas = require.context('../../assets/images/origins/star-wars-9-l-ascension-de-skywalker', false);
    return datas.keys().map(image => datas(image));
}